import http from '../utils/request'

/**
 * 组织机构接口 — 对应后端 OrgController (/api/org)
 */

export const getOrgTree = (keyword) => http.get('/org/tree', { params: { keyword } })
export const getOrgList = () => http.get('/org')
export const getOrg = (guid) => http.get(`/org/${guid}`)
export const saveOrg = (org) => http.post('/org', org)
export const deleteOrg = (guid) => http.delete(`/org/${guid}`)
export const getOrgUsers = (orgGuid) => http.get(`/org/${orgGuid}/users`)
export const addOrgUser = (orgGuid, user) => http.post(`/org/${orgGuid}/users`, user)
export const removeOrgUser = (orgGuid, account) => http.delete(`/org/${orgGuid}/users/${encodeURIComponent(account)}`)
